import { DestroyRef, Inject, inject, Pipe, PipeTransform } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { map } from 'rxjs/operators';
import { LabelType } from '@fatigue/app/core/enums/label';
import { ENVIRONMENT } from '@fatigue/app/core/providers/environment.provider';
import { LanguagesSelectService } from '@fatigue/app/core/store/selectors/languages.selector';
import { Environment } from '@fatigue/environments/env';

interface ILangObject {
  [key: string]: string;
}

@Pipe({ standalone: true, name: 'lang', pure: false })
export class LangPipe implements PipeTransform {
  private readonly _destroyRef = inject(DestroyRef);
  private _langs: ILangObject = {};
  private _showLabel: boolean | undefined = false;

  constructor(
    private _languagesSelect: LanguagesSelectService,
    @Inject(ENVIRONMENT) private _env: Environment,
  ) {
    if (_env.name === 'dev' || _env.name === 'sandbox') {
      this._languagesSelect
        .getDev()
        .pipe(takeUntilDestroyed(this._destroyRef))
        .subscribe((showLabel) => {
          this._showLabel = showLabel;
        });
    }
    this._languagesSelect
      .getLocalizations()
      .pipe(
        map((langs) =>
          langs.reduce<ILangObject>((result, label) => {
            result[label.Key!] = label.Value!;
            return result;
          }, {}),
        ),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe((langs) => {
        this._langs = langs;
      });
  }

  public transform(langKey: typeof LabelType | string | undefined | null, defaultMessage: string = ''): string {
    if (this._showLabel) {
      return langKey! as string;
    }
    const _langKey = (langKey as string)?.toLocaleLowerCase();
    if (_langKey && this._langs[_langKey]) {
      return this._langs[_langKey] || defaultMessage;
    }
    if (defaultMessage) {
      return defaultMessage;
    }
    return _langKey || defaultMessage || '';
  }
}
